import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const RadioGroup = ({ question, options, value, onChange }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <div div className="radio-group-container">
      {question ? (
        <p className="radio-group-question">{t(`${routeName}.${question}`)}</p>
      ) : null}
      {options?.map(option => {
        return (
          <div
            key={option.value}
            className="radio-group-option"
            onClick={() => onChange(option.value)}
          >
            <div
              className={`radio-group-button ${
                value === option.value && "checked"
              }`}
            >
              {value === option.value ? (
                <div className={"inner-circle"} />
              ) : null}
            </div>
            <div className="radio-group-label">
              {t(`${routeName}.${option?.label}`)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RadioGroup;
